import { createContext } from 'react';

export const EventTypeContext = createContext(undefined);
export const EventTypeProvider = EventTypeContext.Provider;
